
const ProgressBarComponent = {
    restrict: 'E',
    template: require('./progress-bar.html'),
    bindings: {
        max: '<',
        current: '<',
        message: '@'
    },
    controllerAs: 'vm',
    controller: [
        function progressBarController() {
    
            var onePercent = 100;
            var vm = this;
            vm.percentage = 0;
        
            vm.$onInit = function () {
                onePercent = 100 / vm.max;
            };
        
            vm.$onChanges = function (change) {
                if (change.current && change.current.currentValue) {
                    var percent = onePercent * change.current.currentValue;
                    vm.percentage = (percent > 100 ? 100 : percent) + "%";
                }
            };
        }
    ]
};

export default ProgressBarComponent;
